export const MEMBER_UPDATE_REQUEST_FIELD_LABELS = {
  firstName: 'Ad',
  lastName: 'Soyad',
  email: 'E-posta',
  phoneNumber: 'Telefon',
  jobTitle: 'Ünvan',
  company: 'Şirket',
  sector: 'Sektör',
  university: 'Üniversite',
  highSchool: 'Lise',
  address: 'Adres',
  workAddress: 'İş adresi',
  tcKimlikNo: 'TC Kimlik No',
  birthDate: 'Doğum tarihi',
  clubJoinDate: 'Kulübe giriş tarihi',
  website: 'Web sitesi',
  hobbies: 'Hobiler',
  facebook: 'Facebook',
  twitter: 'X (Twitter)',
  linkedIn: 'LinkedIn',
  profilePictureUrl: 'Profil fotoğrafı',
};

export const MEMBER_UPDATE_REQUEST_FIELD_ORDER = [
  'firstName',
  'lastName',
  'email',
  'phoneNumber',
  'tcKimlikNo',
  'birthDate',
  'jobTitle',
  'company',
  'sector',
  'university',
  'highSchool',
  'address',
  'workAddress',
  'clubJoinDate',
  'website',
  'hobbies',
  'facebook',
  'twitter',
  'linkedIn',
  'profilePictureUrl',
];

const DATE_FIELDS = new Set(['birthDate', 'clubJoinDate']);

const isEmptyValue = (value) => value === null || value === undefined || String(value).trim() === '';

const normalizeDatePart = (value) => {
  if (isEmptyValue(value)) return '';
  const str = String(value).trim();
  const match = str.match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : str;
};

export const normalizeMemberUpdateRequestValue = (value, field) => {
  if (isEmptyValue(value)) return '';
  if (DATE_FIELDS.has(field)) return normalizeDatePart(value);
  return String(value).trim();
};

export const formatMemberUpdateRequestDisplayValue = (value, field) => {
  if (isEmptyValue(value)) return '-';
  if (DATE_FIELDS.has(field)) {
    const datePart = normalizeDatePart(value);
    const [year, month, day] = datePart.split('-').map(Number);
    if (!year || !month || !day) return datePart;
    const d = new Date(year, month - 1, day);
    if (Number.isNaN(d.getTime())) return datePart;
    return d.toLocaleDateString('tr-TR');
  }
  if (field === 'profilePictureUrl') {
    const str = String(value).trim();
    const parts = str.split('/');
    return parts[parts.length - 1] || str;
  }
  return String(value).trim();
};

export const getMemberUpdateRequestChanges = (oldData = {}, newData = {}) => {
  const extraFields = [
    ...new Set([
      ...Object.keys(oldData || {}),
      ...Object.keys(newData || {}),
    ]),
  ].filter((field) => !MEMBER_UPDATE_REQUEST_FIELD_ORDER.includes(field));

  const fields = [...MEMBER_UPDATE_REQUEST_FIELD_ORDER, ...extraFields.sort()];

  return fields
    .map((field) => {
      const oldNormalized = normalizeMemberUpdateRequestValue(oldData?.[field], field);
      const newNormalized = normalizeMemberUpdateRequestValue(newData?.[field], field);
      if (oldNormalized === newNormalized) return null;
      return {
        field,
        label: MEMBER_UPDATE_REQUEST_FIELD_LABELS[field] || field,
        oldDisplay: formatMemberUpdateRequestDisplayValue(oldData?.[field], field),
        newDisplay: formatMemberUpdateRequestDisplayValue(newData?.[field], field),
      };
    })
    .filter(Boolean);
};
